import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { UiStoreModule } from './ui-store/ui-store.module';
import { AuthStoreModule } from './auth-store/auth-store.module';
import { LogTicketsModule } from './log-tickets-store/log-tickets-store.module';
import { DataSourceConfigsStoreModule } from './data-source-configs-store/data-source-configs-store.module';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { UsersStoreModule } from './users-store/users-store.module';
import { RolesStoreModule } from './roles-store/roles-store.module';
import { FormsStoreModule } from './forms-store/forms-store.module';
import { ReportsStoreModule } from './reports-store/reports-store.module';
import { TenantsStoreModule } from './tenants-store/tenants-store.module';
import { LookupStoreModule } from './lookup-store/lookup-store.module';
import { VehiclesStoreModule } from './vehicles-store/vehicles-store.module';
import { DashboardsStoreModule } from './dashboards-store/dashboards-store.module';
import { WorkSplitStoreModule } from './work-split-store/work-split-store.module';
import { AuditStoreModule } from './audit-store/audit-store.module';
import { UpdatetypeStoreModule } from './update-type-store/update-type-store.module';
import { ManagedTourStoreModule } from './managed-tour-store/managed-tour.module';
import { CustomerStoreModule } from './customer-store/customer-store.module';
import { MyToursStoreModule } from './my-tours-store/my-tours.module';
import { EmailTriggerStoreModule } from './email-trigger-store/email-trigger-store.module';
import { TransportStoreModule } from './transport-store/transport.module';
import { QuotesStoreModule } from './quotes-store/quotes-store.module';
import { ControlTowerModule } from './control-tower-store/control-tower-store.module';
import { CustomsStoreModule } from './customs-store/customs-store.module';
import { DriverTrackingStoreModule } from './driver-tracking-store/driver-tracking-store.module';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forRoot([], { developmentMode: environment.enableNgxsDevMode }),
    NgxsRouterPluginModule.forRoot(),
    NgxsFormPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: !environment.enableNgxsDevMode, name: 'AMCO.UI NGXS DevTools' }),
    NgxsLoggerPluginModule.forRoot({ disabled: !environment.enableNgxsDevMode }),
    NgxsStoragePluginModule.forRoot({
      key: [
        'auth',
        'ui',
        'ManagedTours',
        'MyTours.selectedTourIds'
      ]
    }),
    UiStoreModule,
    AuthStoreModule,
    LogTicketsModule,
    DataSourceConfigsStoreModule,
    UsersStoreModule,
    RolesStoreModule,
    ReportsStoreModule,
    FormsStoreModule,
    TenantsStoreModule,
    LookupStoreModule,
    ManagedTourStoreModule,
    MyToursStoreModule,
    TransportStoreModule,
    QuotesStoreModule,
    EmailTriggerStoreModule,
    CustomerStoreModule,
    AuditStoreModule,
    VehiclesStoreModule,
    DashboardsStoreModule,
    WorkSplitStoreModule,
    UpdatetypeStoreModule,
    ControlTowerModule,
    CustomsStoreModule,
    DriverTrackingStoreModule
  ],
  declarations: []
})
export class NgxsStoreModule {}
